import { ColDef } from 'ag-grid-community';

export class CIJobTypesGridColumnsModel {
	/**
	 * Return columns configuration.
	 * @param loanTypes
	 */
	getColumns(): Array<ColDef> {

		return [
			{
				headerName: 'Origin',
				width: 120,
				field: 'origin',
			},
			{
				headerName: 'Product',
				width: 220,
				field: 'productName',
			},
			{
				headerName: 'Form Type',
				width: 120,
				field: 'formName',
			},
			{
				headerName: 'Hybrid Product',
				width: 80,
				field: 'isHybridProduct'
			},
			{
				headerName: 'Actions',
				width: 100,
				cellRenderer: 'customActionCIJobTypesCellComponent'
			}
		];
	}
}
